import axios from 'axios';
import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { BP_UPDATE } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

const api_invoices = (clientId) => {

    return (dispatch, getState) => {

        Auth.currentSession().then((session) => {

            const token = session && session.idToken.jwtToken;

            var config = { headers: { Authorization: 'Bearer ' + token } };

            return axios.get(`${Config.API_BASE_URL}/bp/admin/client-exception-get/${clientId}`, config)
                .then(response => {
                    dispatch({
                        type: BP_UPDATE,
                        payload: {
                            exceptionsPartners: response.data.partners,
                            exceptions: response.data.exceptions,
                            exceptionsProducts: response.data.products,
                        }
                    });
                })
                .catch(error => {

                    throw (error);
                });

        }).catch(error => {

            // dispatch({ type: EXPIRED });
        });
    };
}

export default api_invoices;
